// This file is automatically generated. Do not edit it directly.
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';

const SUPABASE_URL = "https://vzvcrmczhmtkmtszmhct.supabase.co";
const SUPABASE_PUBLISHABLE_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InZ6dmNybWN6aG10a210c3ptaGN0Iiwicm9sZSI6ImFub24iLCJpYXQiOjE3NTY3NTQxMTIsImV4cCI6MjA3MjMzMDExMn0.mG948lyg855_nKKTblnkUc7r5aWXffqAAdLmloyVA0c";

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY, {
  auth: {
    storage: localStorage,
    persistSession: true,
    autoRefreshToken: true,
  }
});